import {
  bizURL,
  cmsURL,
  courseURL,
  localUrl,
  examURL,
  statURL,
  questionbankUrl,
  payUrl
} from './baseURL'
import axios from 'axios'
import qs from 'qs'


import port from '@/apiCloud/port'
import request from '@/utilsCloud/request'

// let basePath = '/test-api'
let basePath = '/prod-api'

//企业数据
//get
export function getBizList(apiUrl, data) {
  const url = bizURL + apiUrl;
  var entpId = "";
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
  } else if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  // console.log("clh=======>tokenId",tokenId);
  // console.log("clh=======>entpId",entpId);


  if (data) {
    data.tokenId = tokenId
    data.entpId = entpId;
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}
//post
export function getBizListByPost(apiUrl, data) {
  const url = bizURL + apiUrl
  var entpId = '';
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  } else if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  if (data) {
    data.tokenId = tokenId
    data.entpId = entpId;
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.post(url, qs.stringify(data), {

  //   })
  //   .then(res => {
  //     // console.log(1111,res)
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'post',
    params: data
  })
}
//登录
export function loginByPost(apiUrl, data) {
  const url = basePath + '/auth/login'
  var entpId = ""
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  // if (data) {
  //   data.entpId = entpId
  // } else {
  //   data = {
  //     entpId
  //   }
  // }
  // const url = bizURL + apiUrl
  // return axios.post(url, data, {
  //     headers: {
  //       'Content-Type': 'application/json;charset=utf-8'
  //     },
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

//新闻数据
//get
export function getCmsList(apiUrl, data) {
  const url = cmsURL + apiUrl
  var entpId = ""
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  if (data) {
    data.tokenId = tokenId
    data.entpId = entpId
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     // console.log(res)
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}
//post
export function getCmsListByPost(apiUrl, data) {
  const url = cmsURL + apiUrl
  var entpId = "";
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  if (data) {
    data.tokenId = tokenId
    data.entpId = entpId
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.post(url, qs.stringify(data), {})
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'post',
    params: data
  })
}
//课程数据
//get
export function getCourseList(apiUrl, data) {
  const url = courseURL + apiUrl
  var entpId = "";
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  // console.log(111,localStorage.getItem("enterpriseId"))
  if (data) {
    data.tokenId = tokenId
    data.entpId = entpId
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}
//获取线上课程数据
export function getCourseCatetoryPatentSubsetByTokenIdAndVideo(apiUrl, data) {
  const url = courseURL + apiUrl
  var entpId = "";
  var tokenId = "";
  // if (localStorage.getItem("tokenId")) {
  //   tokenId = localStorage.getItem('tokenId');
  // }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  if (data) {
    data.tokenId = tokenId
    data.entpId = entpId
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}
//课程数据
//get
export function getCourseListByStatURL(apiUrl, data) {
  const url = statURL + apiUrl
  var entpId = "";
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  // console.log(111,localStorage.getItem("enterpriseId"))
  if (data) {
    data.tokenId = tokenId
    data.entpId = entpId
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}
//获取是否课程已经学完
export function getEmployeeCourseOverStatus(apiUrl, data) {
  const url = statURL + apiUrl
  let tokenId = ""
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  }
  if (data) {
    data.tokenId = tokenId
  } else {
    data = {
      tokenId,
    }
  }
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}
//审核不通过提交审核
export function commitApprovalPackageRecords(apiUrl, data) {
  const url = statURL + apiUrl
  if (data) {
    data.tokenId = localStorage.getItem('tokenId')
  } else {
    data = {
      tokenId: localStorage.getItem('tokenId')
    }
  }
  // return axios.post(url, {
  //   params: data,
  // })
  // .then(res => {
  //   return Promise.resolve(res.data)
  // })
  // return axios.post(url, qs.stringify(data), {})
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}
//课程数据
//get
export function getExamList(apiUrl, data) {
  const url = examURL + apiUrl
  var entpId = "";
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  // console.log(111,localStorage.getItem("enterpriseId"))
  if (data) {
    data.tokenId = tokenId
    data.entpId = entpId
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })

  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}
//获取练习次数
export function getEmployeeExerciseCountByExerciseId(apiUrl, data) {
  const url = examURL + apiUrl
  let tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
  }
  if (data) {
    data.tokenId = tokenId
    // data.entpId = entpId
  } else {
    // data = {
    //   entpId
    // }
  }
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}
//线下课程
export function getOfflineCourseList(apiUrl, data) {
  const url = courseURL + apiUrl
  var entpId = "";
  var tokenId = "";
  var entpCreditNo = ""
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
  }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  if (localStorage.getItem("entpCreditNo") == "91420106MA4KR9RM68") {
    entpId = ''
  }
  if (data) {
    // data.tokenId = tokenId,
    data.entpId = entpId
  } else {
    data = {
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })

  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}
// export function getOfflineCourseList1(apiUrl, data) {
//   const url = bizURL + apiUrl
//   var entpId="";
//   var tokenId="";
//   var entpCreditNo=""
//   if (localStorage.getItem("tokenId")) {
//      tokenId = localStorage.getItem('tokenId');
//   }
//   if(localStorage.getItem("enterpriseId")){
//     entpId=localStorage.getItem("enterpriseId");
//   }
//   // if(localStorage.getItem("entpCreditNo")=="91420106MA4KR9RM68"){
//   //   entpId=''
//   // }
//   if (data) {
//     // data.tokenId = tokenId,
//     data.entpId = entpId
//   } else {
//     data = {entpId}
//   }
//   // data.tokenId=localStorage.getItem('tokenId')
//   return axios.get(url, {
//     params: data,
//   })
//     .then(res => {
//       return Promise.resolve(res.data)
//     })
// }
//post
export function getOfflineCourseListByPost(apiUrl, data) {
  const url = courseURL + apiUrl
  var entpId = "";
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  if (data) {
    // data.tokenId = tokenId
    data.entpId = entpId
  } else {
    data = {
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.post(url, qs.stringify(data), {})
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}



export function getCourseListByPost(apiUrl, data) {
  const url = courseURL + apiUrl
  var entpId = "";
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  if (data) {
    data.tokenId = tokenId
    data.entpId = entpId
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.post(url, qs.stringify(data), {

  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

// 激活课程
export function getActiveCoursesByPost(apiUrl, data) {
  const url = courseURL + apiUrl
  var entpId = "";
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  if (data) {
    data.tokenId = tokenId
    data.entpId = entpId
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.post(url, data)
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}




/*考试中心*/
//get
export function getExam(apiUrl, data) {
  const url = examURL + apiUrl
  var entpId = ""
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  if (data) {
    data.tokenId = tokenId;
    data.entpId = entpId
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}

export function getExamByPost(apiUrl, data) {
  const url = examURL + apiUrl
  var entpId = ""
  var tokenId = "";
  if (localStorage.getItem("tokenId")) {
    tokenId = localStorage.getItem('tokenId');
    // console.log("tokenid",tokenId)
  }
  if (localStorage.getItem("enterpriseId")) {
    entpId = localStorage.getItem("enterpriseId");
  }
  if (data) {
    data.tokenId = tokenId
    data.entpId = entpId
  } else {
    data = {
      tokenId,
      entpId
    }
  }
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.post(url, qs.stringify(data), {})
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}
export function getLatestNotice(apiUrl, data) {
  const url = questionbankUrl + apiUrl
  // return axios.get(url, {})
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}

export function addOrderPaymentPost(apiUrl, data) {
  const url = payUrl + apiUrl

  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.post(url, qs.stringify(data), {

  //   })
  //   .then(res => {
  //     // console.log(1111,res)
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}
export function getOrderPaymentGet(apiUrl, data) {
  const url = payUrl + apiUrl

  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}




//直播详情
export function getLiveDetail(apiUrl, data) {
  const url = courseURL + apiUrl
  // data.tokenId=localStorage.getItem('tokenId')
  // return axios.get(url, {
  //     params: data,
  //   })
  //   .then(res => {
  //     return Promise.resolve(res.data)
  //   })
  return request({
    url: url,
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/service.js